import { API_XBI4_URL } from "../../config";

export const createUser = async (org_id: any, data: any) => {
  const orgId = org_id || 100000000001;
  const res = await fetch(`${API_XBI4_URL}/orgs/${orgId}/portal-users`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json?.error || "Could not create the user");
  }
  return json;
};

export const getPortalRoles = async (org_id: any) => {
  const orgId = org_id || 100000000001;
  const res = await fetch(`${API_XBI4_URL}/orgs/${orgId}/portal-roles`);
  const json = await res.json().catch(() => []);
  return Array.isArray(json) ? json : [];
};
